<template>
    <div>
        <v-col cols="12">
            <v-row style="text-align: right;">
                <v-col cols="4">
                    <v-text-field label="Search..." dense v-model="search" hide-details></v-text-field>
                </v-col>
                <v-col cols="4"></v-col>
                <v-col cols="4"><v-btn color="primary" @click="actionItem('Add',null)" v-if="roles.create_material">Add Raw Material</v-btn></v-col>
            </v-row>
        </v-col>

        <v-divider class="mx-4" inset horizontal></v-divider>

        <!-- <v-simple-table fixed-header height="95vh">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="cell-border">Thumbnail</th>
                        <th class="cell-border">Material Code</th>

                        <th class="cell-border">Type</th>

                        <th class="cell-border">Variant</th>

                        <th class="cell-border">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(i,indexi) of listRawMaterial">
                        <tr :key="indexi">
                            <td class="cell-border" :rowspan="i.variants.length">
                                <img :src="i.material_thumbnail" style="width: 150px;"/>
                            </td>
                            <td class="cell-border" :rowspan="i.variants.length">
                                {{ i.material_code }}
                            </td>
                            <td class="cell-border" :rowspan="i.variants.length">
                                {{ i.material_type }}
                            </td>
                            <td class="cell-border">
                                {{ i.variants[0].variant_name }}
                            </td>
                            <td class="cell-border">
                                <v-btn x-small color="primary">
                                    <v-icon small color="white">mdi-pencil</v-icon>
                                </v-btn>
                                &nbsp;
                                <v-btn x-small color="orange">
                                    <v-icon small color="white">mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <template v-for="(j,indexj) of i.variants">
                            <template v-if="indexj != 0">
                                <tr :key="indexj">
                                    <td class="cell-border">
                                        {{ j.variant_name }}
                                    </td>
                                    <td class="cell-border">
                                        <v-btn x-small color="primary">
                                            <v-icon small color="white">mdi-pencil</v-icon>
                                        </v-btn>
                                        &nbsp;
                                        <v-btn x-small color="orange">
                                            <v-icon small color="white">mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </template>
                </tbody>
            </template>
        </v-simple-table> -->
    
        <v-data-table
                :headers="headers"
                :items="listRawMaterial"
                :options.sync="pagination"
                :loading="loading"
                class="elevation-1"
                :search="search"
                :footer-props="{
                'items-per-page-options': [10, 20, 50, 100, 200, 500, 800, 1000],
                }"
            >
            <template v-slot:item.thumbnail="{ item }">
                <img :src="item.material_thumbnail" style="width: 150px;"/>
            </template>
            <template v-slot:item.variants="{ item }">                

                <v-menu
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    persistent
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <a v-bind="attrs" v-on="on">
                            {{ item.variants.length }} variant(s)
                        </a>
                    </template>
                    <v-card class="mx-auto status-scroll" max-width="344" max-height="60vh" outlined>
                        <v-col
                        cols="12"
                        three-line
                        v-for="(i, index) in item.variants"
                        :key="index"
                        class="border"
                        style="text-align: left; font-size: 12px; background-color: white;"
                        >
                        <!-- <template v-if="index == item.order_statuses.length-1"> -->
                            <b>{{index + 1}}. {{ i.variant_name }}</b>
                        </v-col>
                    </v-card>
                    </v-menu>
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn x-small color="primary" v-if="roles.update_material || roles.read_material">
                    <v-icon small color="white" @click="actionItem('Edit',item._id)">mdi-pencil</v-icon>
                </v-btn>
                &nbsp;
                <v-btn x-small color="orange" v-if="roles.delete_material">
                    <v-icon small color="white">mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        
        <BaseDialog :active.sync="dialogAction" dialog_name="Raw Material Action">
            <RawMaterialAction
                :selectedItem="selectedItem"
                :action="action"
                :roles="roles"
            />
        </BaseDialog>
    </div>
</template>

<script>

    import axios from "axios";
    import Amplify, { Auth } from "aws-amplify";
    import BaseDialog from "../Common/c-base-dialog";
    import RawMaterialAction from "./raw-material-dialog-action.vue"
    
    Amplify.configure({
        Auth: {
            region: "ap-southeast-1",
            userPoolId: "ap-southeast-1_8vBdk5PAd",
            userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
            mandatorySignIn: true,
        },
    });

    export default {
        name:"RawMaterial",

        components:{
            BaseDialog,
            RawMaterialAction
        },

        data: () => ({
            loading: false,
            informText:'',
            roles: [],
            alertError: false,
            alertSuccess: false,
            search:"",

            listRawMaterial: [],
            listRawMaterialBackup: [],

            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: false,
                groupDesc: false,
                multiSort: false,
                mustSort: false,
            },

            headers:[
                { text: "Thumbnail", value: "thumbnail" },
                { text: "Material Code", value: "material_code" },
                { text: "Material Type", value: "material_type" },
                { text: "Variants", value: "variants" },
                { text: "Action", value: "action" },
            ],

            action: "",
            selectedItem: null,
            dialogAction: false,
        }),
        
        created() {
            this.$root.$refs.rawMaterial = this;
        },

        methods:{
            getParams() {
                let queryParams = {
                    page: this.pagination.page,
                    itemsPerPage: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy[0],
                    sortDesc: this.pagination.sortDesc[0],
                };

                return queryParams;
            },

            async loadData(){
                this.loading = true;
                let queryParams = this.getParams();

                var currentSession = await this.$root.$refs.App.currentSession(
                    "rawMaterial-loadData"
                );

                if (currentSession.accessToken) {
                    await axios
                    .get(window.domain + "raw-materials", {
                        headers: { Authorization: currentSession.accessToken },
                        params: queryParams,
                    })
                    .then((response) => {
                        // console.log(this.AuthStr)
                        console.log(response);
                        this.listRawMaterial = response.data.data.rawMaterials;
                        this.listRawMaterialBackup = JSON.parse(JSON.stringify(this.listRawMaterial))
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        this.loading = false;
                        this.listRawMaterial = [];
                    });
                } else {
                    console.log(
                    "currentSession rawMaterial-loadData-undefined: ",
                    currentSession
                    );
                }
            },

            actionItem(action,item){
                this.action = action
                this.selectedItem = item

                this.dialogAction = !this.dialogAction
            },

            deleteItem(){

            },

            turnOffDialog(){
                this.dialogAction = false;

                this.loadData();
            }

        },

        async mounted(){
            this.roles = await this.$cookies.get("raw_materials");
            if (this.roles.list_materials) {
                console.log("OK");
            } else {
                this.$router.push("/not-authorized");
            }

            try {
                await Auth.currentAuthenticatedUser({ bypassCache: false });
                this.loadData();
            } catch (error) {
                console.log("User logged out!");
                this.$router.push("/login");
            }
        }
    }
</script>

<style lang="scss" scoped>
.cell-border{
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cell-color{
    background-color: #D9EAD3;
}

.resize-div{
    resize: both;
  overflow: auto;
  display: block;
}
</style>